const { componentsThemeManager } = require('./helpers/themeHelpers');

const components = import.meta.webpackContext('./components', {
  recursive: true,
  regExp: /index.js$/,
  mode: 'lazy',
  chunkName: '[request]',
});

// all components must be in a folder with the component name, and have an index.js file
// e.g. ./descope-button/index.js
module.exports = components.keys().reduce((acc, key) => {
  const componentName = key.replace(/.*?([^\/]+)\/index\.js$/, '$1');

  if (componentName.endsWith('-internal')) {
    return acc;
  }

  acc[componentName] = () => components(key);

  return acc;
}, {});

module.exports.componentsThemeManager = componentsThemeManager;

module.exports['descope-address-field'] = () => import(/* webpackChunkName: "descope-address-field" */ '@descope-ui/descope-address-field');
module.exports['descope-apps-list'] = () => import(/* webpackChunkName: "descope-apps-list" */ '@descope-ui/descope-apps-list');
module.exports['descope-autocomplete-field'] = () => import(/* webpackChunkName: "descope-autocomplete-field" */ '@descope-ui/descope-autocomplete-field');
module.exports['descope-avatar'] = () => import(/* webpackChunkName: "descope-avatar" */ '@descope-ui/descope-avatar');
module.exports['descope-badge'] = () => import(/* webpackChunkName: "descope-badge" */ '@descope-ui/descope-badge');
module.exports['descope-button'] = () => import(/* webpackChunkName: "descope-button" */ '@descope-ui/descope-button');
module.exports['descope-collapsible-container'] = () => import(/* webpackChunkName: "descope-collapsible-container" */ '@descope-ui/descope-collapsible-container');
module.exports['descope-combo-box'] = () => import(/* webpackChunkName: "descope-combo-box" */ '@descope-ui/descope-combo-box');
module.exports['descope-country-subdivision-city-field'] = () => import(/* webpackChunkName: "descope-country-subdivision-city-field" */ '@descope-ui/descope-country-subdivision-city-field');
module.exports['descope-enriched-text'] = () => import(/* webpackChunkName: "descope-enriched-text" */ '@descope-ui/descope-enriched-text');
module.exports['descope-icon'] = () => import(/* webpackChunkName: "descope-icon" */ '@descope-ui/descope-icon');
module.exports['descope-image'] = () => import(/* webpackChunkName: "descope-image" */ '@descope-ui/descope-image');
module.exports['descope-link'] = () => import(/* webpackChunkName: "descope-link" */ '@descope-ui/descope-link');
module.exports['descope-list'] = () => import(/* webpackChunkName: "descope-list" */ '@descope-ui/descope-list');
module.exports['descope-list-item'] = () => import(/* webpackChunkName: "descope-list-item" */ '@descope-ui/descope-list-item');
module.exports['descope-outbound-app-button'] = () => import(/* webpackChunkName: "descope-outbound-app-button" */ '@descope-ui/descope-outbound-app-button');
module.exports['descope-outbound-apps'] = () => import(/* webpackChunkName: "descope-outbound-apps" */ '@descope-ui/descope-outbound-apps');
module.exports['descope-password-strength'] = () => import(/* webpackChunkName: "descope-password-strength" */ '@descope-ui/descope-password-strength');
module.exports['descope-ponyhot'] = () => import(/* webpackChunkName: "descope-ponyhot" */ '@descope-ui/descope-ponyhot');
module.exports['descope-recovery-codes'] = () => import(/* webpackChunkName: "descope-recovery-codes" */ '@descope-ui/descope-recovery-codes');
module.exports['descope-text'] = () => import(/* webpackChunkName: "descope-text" */ '@descope-ui/descope-text');
module.exports['descope-timer'] = () => import(/* webpackChunkName: "descope-timer" */ '@descope-ui/descope-timer');
module.exports['descope-timer-button'] = () => import(/* webpackChunkName: "descope-timer-button" */ '@descope-ui/descope-timer-button');
module.exports['descope-tooltip'] = () => import(/* webpackChunkName: "descope-tooltip" */ '@descope-ui/descope-tooltip');
module.exports['descope-trusted-devices'] = () => import(/* webpackChunkName: "descope-trusted-devices" */ '@descope-ui/descope-trusted-devices');
